const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/oauth-clients/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requireEditOrganizationPermission } from '@/lib/queries/access/usePermissions';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/oauth-clients')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    context
  }) => {
    await requireEditOrganizationPermission(context);
  },
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.settings.oauthClients.title)
  })
});